import { Component } from '@angular/core';

@Component({
  selector: 'app-docu-upsell-logo-dialog',
  templateUrl: './docu-upsell-logo-dialog.component.html',
  styleUrls: ['./docu-upsell-logo-dialog.component.scss'],
})
export class DocuUpsellLogoDialogComponent {}
